import React from 'react';
import { FiX, FiUser, FiFileText } from 'react-icons/fi';
import { getCaseProfile, getLocalizedCaseDisplay } from '../../data/caseProfiles';
import { useLanguage } from '../../context/LanguageContext';
import './AnketaPanel.css';

const AnketaPanel = ({ isOpen, onClose, caseData }) => {
  const { language, t } = useLanguage();

  if (!isOpen || !caseData) return null;

  const displayCase = getLocalizedCaseDisplay(caseData, language);
  const profile = getCaseProfile(caseData);
  const demographics = {
    ...profile.demographics,
    sex: displayCase.gender || profile.demographics?.sex,
    setting: displayCase.setting || profile.demographics?.setting
  };

  return (
    <aside className="anketa-panel" aria-label={t('medicalCaseAnketa')}>
      <div className="anketa-panel-header">
        <div>
          <h3>{t('medicalCaseAnketa')}</h3>
        </div>
        <button className="anketa-close-btn" onClick={onClose} title={t('closeAnketa')}>
          <FiX size={20} />
        </button>
      </div>

      <div className="anketa-panel-content">
        <div className="anketa-patient-title">
          <FiUser />
          <strong>{displayCase.name}</strong>
        </div>

        <div className="anketa-grid">
          <div>
            <span>{t('age')}</span>
            <strong>{displayCase.age} {t('years')}</strong>
          </div>
          <div>
            <span>{t('gender')}</span>
            <strong>{demographics.sex || t('notAvailable')}</strong>
          </div>
          <div>
            <span>{t('setting')}</span>
            <strong>{demographics.setting || t('patientInterview')}</strong>
          </div>
        </div>

        <section className="anketa-section">
          <div className="anketa-section-title">
            <FiFileText />
            <span>{t('chiefComplaint')}</span>
          </div>
          <p>{displayCase.chiefComplaint}</p>
        </section>

        {(displayCase.triage || profile.initialChart?.triage) && (
          <section className="anketa-section">
            <div className="anketa-section-title">
              <FiFileText />
              <span>{t('triageLine')}</span>
            </div>
            <p>{displayCase.triage || profile.initialChart.triage}</p>
          </section>
        )}
      </div>
    </aside>
  );
};

export default AnketaPanel;
